import CCColors from '@/Utils/CCColors';

export const PRACTICE_VERDICT_STYLE: Record<
  string,
  {title: string; icon: string; color: string; bg: string}
> = {
  best: {
    title: 'Best move!',
    icon: 'checkmark-circle',
    color: CCColors.Green,
    bg: CCColors.Workbook.AquaTint,
  },
  good: {
    title: 'Good move',
    icon: 'checkmark-circle-outline',
    color: CCColors.Green,
    bg: CCColors.Workbook.AquaTint,
  },
  inaccuracy: {
    title: 'Inaccuracy',
    icon: 'alert-circle-outline',
    color: CCColors.Workbook.GoldDeep,
    bg: CCColors.Workbook.CreamLight,
  },
  mistake: {
    title: 'Mistake',
    icon: 'close-circle-outline',
    color: CCColors.Workbook.Orange,
    bg: CCColors.Workbook.CreamDark,
  },
  blunder: {
    title: 'Blunder',
    icon: 'close-circle',
    color: CCColors.Error,
    bg: CCColors.Workbook.RedTint,
  },
};

export const PRACTICE_VERDICT_COPY: Record<string, string> = {
  best: "That was the engine's top choice in this position.",
  good: 'A solid move — the position stays about the same.',
  inaccuracy: 'Slightly imprecise — there was a stronger continuation.',
  mistake: 'That gives away some of your advantage.',
  blunder: "That's a serious mistake — the evaluation swung sharply.",
};
